import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationTituloReceberModalComponent } from './integration-titulo-receber-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationTituloReceberModalComponent
    ],
    exports: [
        IntegrationTituloReceberModalComponent
    ]
})
export class IntegrationTituloReceberSharedModule { }
